/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Errorboundarydescription2Inputs */

const en_errorboundarydescription2 = /** @type {(inputs: Errorboundarydescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An unexpected error occurred. Please try again or reload the page.`)
};

const de_errorboundarydescription2 = /** @type {(inputs: Errorboundarydescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da ist was schiefgelaufen. Versuch's nochmal oder lade die Seite neu.`)
};

/**
* | output |
* | --- |
* | "An unexpected error occurred. Please try again or reload the page." |
*
* @param {Errorboundarydescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const errorboundarydescription2 = /** @type {((inputs?: Errorboundarydescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Errorboundarydescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_errorboundarydescription2(inputs)
	return de_errorboundarydescription2(inputs)
});
export { errorboundarydescription2 as "errorBoundaryDescription" }